import React from 'react';
import { useNavigate } from 'react-router-dom';

const InsightCard = ({ data, containerStyle = {}, cardStyle = {}, itemStyle = {}, route, filter }) => {

    const navigate = useNavigate();

    return (
        <div
            className="d-flex"
            style={{ gap: '1rem', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: "none", ...containerStyle }}
        >
            {data.map((item, idx) => (
                <div
                    key={idx}
                    className="bg-white rounded shadow-sm text-center p-3"
                    style={{ minWidth: '180px', display: 'inline-block', ...cardStyle }}
                >
                    <div className="text-muted">{item.label}</div>
                    <div style={{ fontSize: '30px', fontWeight: '700', ...itemStyle }} onClick={(e) => { e.preventDefault(); if (route) { navigate(route, { state: filter }); } }}>{item.value}</div>
                </div>
            ))}
        </div>
    );
};

export default InsightCard;
